// Campos de formulario reutilizables (optimizados para tablet)

const inputCls =
  "h-12 w-full border border-slate-300 bg-white rounded-lg px-3 text-base text-slate-900 placeholder:text-slate-400 focus:outline-none focus:border-blue-600 focus:ring-2 focus:ring-blue-600/30 transition-colors";

export function Field({ label, children, required }) {
  return (
    <label className="block space-y-1.5">
      <span className="text-xs uppercase tracking-[0.12em] font-semibold text-slate-500">
        {label} {required && <span className="text-blue-700">*</span>}
      </span>
      {children}
    </label>
  );
}

export function TextInput({ testId, ...props }) {
  return <input data-testid={testId} className={inputCls} {...props} />;
}

export function TextArea({ testId, ...props }) {
  return (
    <textarea
      data-testid={testId}
      className={inputCls + " h-24 py-2 resize-none"}
      {...props}
    />
  );
}

export function SelectInput({ testId, options, groups, placeholder = "Seleccionar…", ...props }) {
  return (
    <select data-testid={testId} className={inputCls} {...props}>
      <option value="">{placeholder}</option>
      {groups
        ? groups.map((g) => (
            <optgroup key={g.label} label={g.label}>
              {g.options.map((o) => {
                const value = typeof o === "string" ? o : o.value;
                const label = typeof o === "string" ? o : o.label;
                return (
                  <option key={value} value={value}>
                    {label}
                  </option>
                );
              })}
            </optgroup>
          ))
        : options.map((o) => {
            const value = typeof o === "string" ? o : o.value;
            const label = typeof o === "string" ? o : o.label;
            return (
              <option key={value} value={value}>
                {label}
              </option>
            );
          })}
    </select>
  );
}

export function EmptyState({ icon: Icon, title, description, action }) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-6">
      {Icon && (
        <div className="w-14 h-14 rounded-2xl bg-slate-100 flex items-center justify-center mb-4">
          <Icon className="w-7 h-7 text-slate-400" strokeWidth={1.5} />
        </div>
      )}
      <h3 className="font-heading font-semibold text-lg text-slate-800">{title}</h3>
      {description && <p className="text-sm text-slate-500 mt-1 max-w-md">{description}</p>}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}
